import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-col justify-center h-6" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "absolute z-0 w-full h-4 bg-gray-500 rounded" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", {
      "data-testid": `metric-bar`,
      "data-progress": _ctx.barWidth,
      style: { width: `${_ctx.barWidth}%` },
      class: "absolute h-4 rounded bg-primary z-1"
    }, null, 12, ["data-progress"]),
    (_ctx.showHighlight)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          style: { left: `${_ctx.barWidth}%` },
          class: "absolute top-0 w-2 h-6 rounded bg-highlight z-2"
        }, null, 4))
      : _createCommentVNode("", true)
  ]))
}